import Reporter from '@/api/clients/reporter/reporter';

export default {
  install: app => {
    const reporterInstance = Reporter();

    app.config.globalProperties.$reporter = reporterInstance;

    app.provide('Reporter', reporterInstance);
  }
};
